module fdm.aircrafts {

    angular.module('fdm.aircrafts')
        .config(['$stateProvider', '$locationProvider',
            ($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {

                dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                    .detailsState('aircraftDetails', 'aircrafts',
                    'aircraft/{aggregateId}/details', {
                        templateUrl: () => '/app/src/aircrafts/aircraft-details-view.html',
                        options: (): dg.actions.IQueryResultDisplayerOptions => {
                            return {
                                //actionOptions: {
                                //    hide: true
                                //}
                            };
                        }
                    })
                    .listState('aircraftLayouts', 'aircraft-layouts',
                    'aircraft-layout/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                    })
                    .listState('aircraftTypeLayouts', 'aircraft-type-layouts',
                    'aircraft-type-layout/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                    })
                    .listState('aircraftFamilyLayouts', 'aircraft-family-layouts',
                    'aircraft-family-layout/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                    })
                    .listState('aircrafts', 'aircrafts',
                    'aircraft/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                    actionColumnEnabled: true,
                                    uiGrid: {
                                        columnDefs: [
                                            
                                            { field: 'aggregate', cellTemplate: '/app/src/aircrafts/aircraft-grid-template-cell.html' },
                                        ]
                                    }
                                })
                            ]
                        }
                    })
                    .listState('engineTypeLayouts', 'engine-type-layouts',
                        'engine-type-layout/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                    });
                
                //.state('app.categories', {
                //    abstract: true,
                //    url: 'categories',
                //    template: '<div ui-view />'
                //})
                //.state('app.categories.activities', {
                //    url: '/activities',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/activities-category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.categories.species', {
                //    url: '/species',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/species-category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.categories.targets', {
                //    url: '/targets',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/targets-category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.categories.categories', {
                //    url: '/category',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/category-dynamic-hierarchy/dynamic-hierarchy-list'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.companyRoleInProject', {
                //    url: 'company-role-in-project',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/company-role-in-project-dynamic-list/dynamic-list-list'
                //                }
                //            }
                //        }]
                //    }
                //})

            }]);

}